const LA_TIMEZONE = 'America/Los_Angeles';
const ROLLOVER_HOUR = 3;

function getLosAngelesParts(date: Date): { year: number; month: number; day: number; hour: number } {
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: LA_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    hourCycle: 'h23',
  });

  const parts = formatter.formatToParts(date);
  const map: Record<string, string> = {};
  for (const part of parts) {
    if (part.type !== 'literal') {
      map[part.type] = part.value;
    }
  }

  return {
    year: Number(map.year),
    month: Number(map.month),
    day: Number(map.day),
    hour: Number(map.hour),
  };
}

function formatDateUTC(date: Date): string {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getDailyLosAngelesDate(now: Date = new Date()): string {
  const parts = getLosAngelesParts(now);
  const base = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
  if (parts.hour < ROLLOVER_HOUR) {
    base.setUTCDate(base.getUTCDate() - 1);
  }
  return formatDateUTC(base);
}

export function formatDailyDisplayDate(dateString: string): string {
  const [yearText, monthText, dayText] = dateString.split('-');
  const year = Number(yearText);
  const month = Number(monthText);
  const day = Number(dayText);
  if (!year || !month || !day) return dateString;
  const date = new Date(Date.UTC(year, month - 1, day));
  const monthName = new Intl.DateTimeFormat('en-US', {
    month: 'long',
    timeZone: 'UTC',
  }).format(date);
  return `${monthName} ${day} ${year}`;
}
